import { FormattedMessage } from 'react-intl'
import { Linking, View } from 'react-native'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { B, H1, I, Paragraph, TextLink } from '@flix/common/elements/typography'
import { emailAddresses, localPhoneNumbers } from '../../../config/companyDetails'
import messages from '../messages'

const Message = styled(Paragraph)`
  text-align: center;
  margin-bottom: ${(props) => props.theme.spacing.large}px;
`

const Footnote = styled(View)`
  margin: ${(props) => props.theme.spacing.larger}px auto 0;
`

export const VerifyEmailMainContent = ({ email }) => (
  <>
    <H1 center marginBottom="larger">
      <FormattedMessage {...messages.verifyEmailTitle} />
    </H1>
    <Message>
      <FormattedMessage {...messages.verifyEmailSentTo} values={{ email: <B>{email}</B> }} />
    </Message>
    <Message>
      <B>
        <FormattedMessage {...messages.verifyEmailToWatchMovies} />
      </B>
    </Message>
    <Message>
      <I>
        <FormattedMessage
          {...messages.verifyEmailCheckSpam}
          values={{
            bold: (
              <B>
                <FormattedMessage {...messages.verifyEmailCheckSpamBold} />
              </B>
            ),
          }}
        />
      </I>
    </Message>
  </>
)

VerifyEmailMainContent.propTypes = {
  email: PropTypes.string.isRequired,
}

export const VerifyEmailFootnoteContent = ({ region }) => (
  <Footnote>
    <Message>
      <I>
        <FormattedMessage
          {...messages.verifyEmailAnyIssuesContact}
          values={{
            email: (
              <TextLink onPress={() => Linking.openURL(`mailto:${emailAddresses.support}`)}>
                {emailAddresses.support}
              </TextLink>
            ),
            phone: (
              <TextLink
                onPress={() =>
                  Linking.openURL(`tel:${localPhoneNumbers[region] || localPhoneNumbers.US}`)
                }
              >
                {localPhoneNumbers[region] || localPhoneNumbers.US}
              </TextLink>
            ),
          }}
        />
      </I>
    </Message>
  </Footnote>
)

VerifyEmailFootnoteContent.propTypes = {
  region: PropTypes.string.isRequired,
}
